/* eslint-disable no-unused-vars */
import {
  publisherReportsFiltersTableActions,
  campaignReportsActions,
  authActions,
} from 'store/actions';

export const localStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const state = store.getState();
  savePublisherReportsFilters(state);
  saveCampaignReportsState(state);

  const { authType } = state.auth;

  if (authType === 'user') {
    userSaveAuth(state);
  }
  if (authType === 'admin') {
    adminSaveAuth(state);
  }
  return result;
};

const savePublisherReportsFilters = (state) => {
  const valueToSave = state.publisherReportsFiltersTable;
  const STORAGE_KEY = publisherReportsFiltersTableActions.STORAGE_KEY;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(valueToSave));
};

const saveCampaignReportsState = (state) => {
  const valueToSave = state.campaignReports;
  const STORAGE_KEY = campaignReportsActions.CAMPAIGN_REPORTS_STORAGE_KEY;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(valueToSave));
};

const userSaveAuth = (state) => {
  const authState = state.auth;
  const { rememberMe = null, ...otherFields } = authState;
  const STORAGE_KEY = authActions.STORAGE_KEY;
  if (rememberMe) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(otherFields));
    sessionStorage.removeItem(STORAGE_KEY);
  } else {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(otherFields));
    localStorage.removeItem(STORAGE_KEY);
  }
};

const adminSaveAuth = (state) => {
  const authState = state.auth;
  const { rememberMe = null, ...otherFields } = authState;
  const STORAGE_KEY = authActions.STORAGE_KEY;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(otherFields));
  sessionStorage.removeItem(STORAGE_KEY);
};
